import React, { useEffect, useState } from "react";
import SelectMood from "./SelectMood";
import MoodInfo from "./MoodInfo";
import { MoodProps } from "../../typings/mood";
import { useDispatch } from "react-redux";
import { setOpenMoodSelectQuestions } from "../../redux/app";
import StepperPage from "../../components/stepper/StepperPage";
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';

export function MoodContainer() {
    const [mood, setMood] = useState<MoodProps>();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const stepComponents = [
        {
            component: SelectMood,
            props: { setMood },
            title: "SelectMood"
        },
        {
            component: MoodInfo,
            props: { mood },
            title: "MoodInfo"
        },
    ]

    useEffect(() => {
        dispatch(setOpenMoodSelectQuestions(false));
    }, [])


    const onClose = () => {
        history.goBack();
    };

    return (

        <div>
            <StepperPage
                containStepperHeader={false}
                components={stepComponents}
                handleBackBrowserButton={false}
                hasBackButton={true}
                onClose={onClose}
            />
        </div>
    )
}